export default __webpack_public_path__ + "static/media/home_hero.c9a9ab5b.jpg";